import React, { useEffect, useRef } from 'react';
import Modal from '../Modal';
import { formatApiDate } from '../../utils/date';

const results = {
  aprobado: { title: 'Pago aprobado', type: 'success' },
  cancelado: { title: 'Pago cancelado', type: 'warning' },
  rechazado: { title: 'Pago rechazado', type: 'error' },
  expirado: { title: 'Pago vencido', type: 'warning' },
};

export default function PointCobroResultModal({ resultado, onClose }) {
  const dialog = useRef(null);
  useEffect(() => {
    if (!resultado) return;
    const previousFocus = document.activeElement;
    dialog.current?.querySelector('button')?.focus();
    return () => { if (previousFocus?.isConnected) previousFocus.focus(); };
  }, [resultado]);

  const config = results[resultado?.estado];
  if (!config) return null;
  const message = [`$${Number(resultado.monto).toFixed(2)}`,
    resultado.fechaPago && formatApiDate(resultado.fechaPago)].filter(Boolean).join(' · ');

  return (
    <div ref={dialog} role="dialog" aria-modal="true" aria-label={config.title}
      onKeyDown={event => {
        if (event.key === 'Escape') { event.preventDefault(); onClose(); }
        // This dialog has a single action; keep keyboard focus inside it.
        if (event.key === 'Tab') { event.preventDefault(); dialog.current?.querySelector('button')?.focus(); }
      }}>
      <Modal isOpen type={config.type} title={config.title} message={message}
        confirmText="Aceptar" onConfirm={onClose} onClose={onClose} />
    </div>
  );
}
